import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { reaction } from "mobx";
import {
  GridContainer,
  GridRow,
  GridColumn,
  Toastr,
} from "arv-reactcomponents";
import Analytics from "../../analytics";
import GTM from "../../analytics/GTM";
import Event from "../../analytics/eventFactory";
import { setPageType, isPdpPage, deduceValuesFromPipedData } from "../../utils";
import { pageType } from "../../constants";
import PdpDetailsBlock from "../../component/PdpDetailsBlock";
import PdpAccordion from "../../component/PdpAccordion";
import PdpBottomCarousels from "../../component/PdpComponents/PdpBottomCarousels";

@inject("ProductStore", "LoginStore", "WishListStore")
@observer
class Pdp extends Component {
  static setMeta(ProductStore) {
    const body = JSON.stringify({ typeId: window.location.pathname });
    ProductStore.getType(body).then(getType => {
      const { type, title, description, keywords } = deduceValuesFromPipedData(
        getType && getType.type,
      );
      if (type && type !== "unknown") {
        document.title = title;
        const metaTag = document.querySelector("meta[name='keywords']");
        if (metaTag) {
          metaTag.setAttribute("content", keywords);
        }
        const metaTag2 = document.querySelector("meta[name='description']");
        if (metaTag2) {
          metaTag2.setAttribute("content", description);
        }
      }
    });
  }
  constructor(props) {
    super(props);
    this.state = {
      ProductLoader: true,
      availiableSizeRatio: 0,
      isPdp: true,
    };
    this.currentPageStats = { currentPage: pageType.pdp };
    this.currentStyleId = this.currentStyleId.bind(this);
    this.initializePdp = this.initializePdp.bind(this);
    this.getPdpDetails = this.getPdpDetails.bind(this);
    this.getWishList = this.getWishList.bind(this);
    this.setWishList = this.setWishList.bind(this);
    this.reactToUrlChange = this.reactToUrlChange.bind(this);
    this.reactToLogIn = this.reactToLogIn.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.initializePdp();
    this.reactToUrlChange();
    this.reactToLogIn();
    this.props.history.replace(
      window.location.pathname + window.location.search,
      {
        ...this.currentPageStats,
      },
    );
  }
  get showPdp() {
    return this.state.isPdp ? "" : "nwc-hide";
  }

  getWishList() {
    if (this.props.LoginStore.isUserLoggedIn) {
      this.props.WishListStore.getWishList();
    }
  }
  setWishList(styleId, isWishListed) {
    if (isWishListed) {
      this.props.WishListStore.deleteWishList(isWishListed.favouriteId).then(
        res => {
          if (res && res.status) {
            Toastr.showToastr({
              className: "nwc-toastr-list-success nw-toastr",
              message: "This item has been removed from your favourites.",
              timeout: 3000,
            });
          }
        },
      );
    } else {
      this.props.WishListStore.wishList(styleId);
    }
  }
  getPdpDetails(styleId) {
    return this.props.ProductStore.getDetails(styleId, true)
      .then(response => response)
      .catch(err => {
        console.log(err);
        this.setState({ isPdp: false });
        Toastr.showToastr({
          className: "nwc-toastr-list-danger nw-toastr",
          message:
            "Sorry! couldn't find that product. Please try something else !",
          timeout: 3000,
        });
      });
  }
  reactToUrlChange() {
    reaction(
      () => this.props.location.pathname,
      () => {
        this.initializePdp();
        window.scrollTo(0, 0);
      },
    );
  }
  reactToLogIn() {
    reaction(
      () => this.props.LoginStore.isUserLoggedIn,
      isUserLoggedIn => {
        if (isUserLoggedIn) {
          this.getWishList();
        }
      },
    );
  }
  currentStyleId() {
    const flag = isPdpPage(this.props.location.pathname);
    const urlPath = this.props.location.pathname.split("-");
    return (flag && urlPath[urlPath.length - 1]) || null;
  }

  initializePdp() {
    this.setState({ ProductLoader: true });
    const isPdp =
      (window.history &&
        window.history.state &&
        window.history.state.state &&
        window.history.state.state.currentPage &&
        window.history.state.state.currentPage === pageType.pdp) ||
      false;
    if (isPdp) {
      Pdp.setMeta(this.props.ProductStore);
    }
    this.initialData();
    this.getWishList();
    setPageType(pageType.pdp);
    Analytics.pageView(window.pageType);
    const isSephoraAdwords =
      window.GL &&
      window.GL.brandJourneyDetails &&
      window.GL.brandJourneyDetails.parentBrandName &&
      window.GL.brandJourneyDetails.parentBrandName[0] === "SEPHORA"
        ? Event.GTMEvent.SEPHORAADWORDS
        : Event.GTMEvent.ADWORDS;
    GTM.pushEvent(isSephoraAdwords);
  }

  pdpAnalytics() {
    const { PdpData } = this.props.ProductStore;
    GTM.pushWithEvent(
      {
        brand: PdpData.mainStyle.brandName,
        id: PdpData.mainStyle.styleId,
        desc: PdpData.mainStyle.name,
        mrp: PdpData.mainStyle.mrpRange ? PdpData.mainStyle.mrpRange.max : 0,
        price: PdpData.mainStyle.sellingPriceRange
          ? PdpData.mainStyle.sellingPriceRange.max
          : 0,
        dscnt: PdpData.mainStyle.discountRange.max,
      },
      "view",
    );
    window.google_tag_params = {
      ecomm_prodid: PdpData.mainStyle.styleId,
      ecomm_totalvalue: PdpData.mainStyle.mrpRange
        ? PdpData.mainStyle.mrpRange.max
        : "0",
      ecomm_pagetype: Event.GTMEvent.PRODUCT,
    };

    const { availiableSizeRatio } = this.state;
    Analytics.trackEvent({
      action: Event.action.COMPLETE_LOAD,
      category: Event.category.PRODUCT_DESCRIPTION_PAGE,
      label: availiableSizeRatio,
      interaction: true,
    });
  }

  initialData() {
    const styleId = this.currentStyleId();
    this.getPdpDetails(styleId).then(response => {
      const sizeRatio =
        response.mainStyle.skus.map(el => el.inStock).filter(el => el).length /
        response.mainStyle.skus.length;
      this.setState({ availiableSizeRatio: sizeRatio.toFixed(2) });
      this.setState({ ProductLoader: false });
      this.pdpAnalytics();
    });
  }

  render() {
    const { PdpData } = this.props.ProductStore;
    const secondaryStyleIds =
      (PdpData && PdpData.mainStyle && PdpData.mainStyle.secondaryStyleIds) ||
      [];
    const { ProductLoader } = this.state;
    const { isUserLoggedIn } = this.props.LoginStore;
    return (
      <Fragment>
        <GridContainer className={`nw-pdp-container ${this.showPdp}`}>
          <GridRow className="nw-pdp-row">
            <GridColumn className="">
              <PdpDetailsBlock
                getPdpDetails={this.getPdpDetails}
                setWishList={this.setWishList}
                wishListData={this.props.WishListStore.wishListData}
                ProductLoader={ProductLoader}
                currentStyleId={this.currentStyleId()}
              />
            </GridColumn>
          </GridRow>
          <GridRow className="nw-pdp-accordion">
            <GridColumn className="nw-pdp-accordion-column">
              <PdpAccordion PdpData={PdpData} />
            </GridColumn>
          </GridRow>
          {PdpData && (
            <PdpBottomCarousels
              styleId={this.currentStyleId()}
              secondaryStyleIds={secondaryStyleIds}
              isUserLoggedIn={isUserLoggedIn}
            />
          )}
        </GridContainer>
      </Fragment>
    );
  }
}

Pdp.wrappedComponent.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  WishListStore: PropTypes.shape({
    deleteWishList: PropTypes.func.isRequired,
    getWishList: PropTypes.func.isRequired,
    wishList: PropTypes.func.isRequired,
    wishListData: PropTypes.object, // eslint-disable-line
  }).isRequired,
  LoginStore: PropTypes.shape({
    isUserLoggedIn: PropTypes.bool.isRequired,
  }).isRequired,
  ProductStore: PropTypes.shape({
    isFetchingData: PropTypes.bool.isRequired,
    getDetails: PropTypes.func.isRequired,
    PdpData: PropTypes.object,
  }).isRequired,
};

export default Pdp;



// WEBPACK FOOTER //
// ./src/pages/Pdp/index.js